<template>
	<div class="bg">
		<Page :theme="isOnboarded ? '' : 'transparent'">
			<template v-slot:content>
				<SafeAreaTop :showClose="false">
					<div class="container">
						<div v-if="!isOnboarded" class="title">{{ t('title') }}</div>
						<div v-if="!isOnboarded" class="subtitle">
							<img :src="require(`@/assets/pre/ny-subtitle/${language}.svg`)" alt="" />
						</div>

						<div v-if="isOnboarded" class="promo">
							<img :src="require(`@/assets/pre/ny-home-promo/${language}.png`)" alt="" />
						</div>
						<div v-if="isOnboarded" class="title-onboarded">
							<i18n-t keypath="title2">
								<span class="color-purple">{{ t('set') }}</span>
								<span class="color-purple">{{ t('with_personal_offer') }}</span>
							</i18n-t>
						</div>
					</div>
				</SafeAreaTop>
			</template>
			<template v-slot:footer>
				<div class="container">
					<div class="list" :class="{ dark: isOnboarded }">
						<span>{{ t('new_year') }}</span>
						<i>•</i>
						<span class="simple">{{ t('new_simple') }}</span>
						<i>•</i>
						<span>{{ t('new_you') }}</span>
					</div>
					<a href="" @click.prevent="goNext" class="btn btn-primary btn-block">{{
						isOnboarded ? t('next') : t('get_to_know')
					}}</a>
				</div>
			</template>
		</Page>
	</div>
</template>

<script>
import SafeAreaTop from '../../components/SafeAreaTop.vue'
import Page from '@/components/Page'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { computed, inject, onMounted } from '@vue/runtime-core'
import useConfig from '@/composition/config.js'
import { useStore } from 'vuex'

export default {
	components: {
		Page,
		SafeAreaTop
	},

	setup() {
		const router = useRouter()
		const config = useConfig()
		const amplitude = inject('amplitude')
		const store = useStore()
		const { t, locale } = useI18n({
			messages: {
				en: {
					title: 'What does 2022 have in store for you? Find out in just a minute and make the "new you" happen',
					set: 'Treat yourself',
					with_personal_offer: 'with Simple Premium',
					title2: '{0} to a healthier new year {1}',
					new_year: 'New Year',
					new_simple: 'New Goals',
					new_you: 'New You',
					get_to_know: 'FIND OUT HERE',
					next: 'Next'
				},
				de: {
					title: 'Erfahre in weniger als einer Minute, was 2022 auf dich wartet',
					set: 'Formuliere',
					with_personal_offer: 'mit einem persönlichen Angebot',
					title2: '{0} deine Vorsätze fürs 2022 {1}',
					new_year: 'Neues Jahr',
					new_simple: 'Neue Version von Simple',
					new_you: 'Neues Ich',
					get_to_know: 'Jetzt mitmachen',
					next: 'Weiter'
				},
				es: {
					title: '¿Qué puedes esperar del 2022?',
					set: 'Fija',
					with_personal_offer: 'con una oferta personalizada',
					title2: '{0} tu propósito de Año Nuevo {1}',
					new_year: 'Mejor año',
					new_simple: 'Mejor Simple',
					new_you: 'Mejor tú',
					get_to_know: 'descúbrelo',
					next: 'Siguiente'
				},
				fr: {
					title: 'Découvrez sans attendre ce que peut vous offrir 2022',
					set: 'Prenez',
					with_personal_offer: 'avec une offre personnelle',
					title2: '{0} une bonne résolution pour la nouvelle année {1}',
					new_year: 'Nouvel An',
					new_simple: 'Nouveau look pour Simple',
					new_you: 'Nouveau vous',
					get_to_know: 'en savoir plus',
					next: 'Suivant'
				},
				it: {
					title: 'Cosa può portare il 2022? Scoprilo in meno di un minuto',
					set: 'Pianifica',
					with_personal_offer: "con un'offerta speciale",
					title2: "{0} i buoni propositi per l'anno nuovo {1}",
					new_year: 'Nuovo anno',
					new_simple: 'Nuovo Simple',
					new_you: 'Nuova versione di te',
					get_to_know: 'Scopri',
					next: 'Avanti'
				},
				pt: {
					title: 'O que o ano de 2022 pode trazer para você? Descubra já.',
					set: 'Defina',
					with_personal_offer: 'com uma oferta personalizada',
					title2: '{0} sua Resolução de Ano-Novo {1}',
					new_year: 'Um ano novo',
					new_simple: 'Um novo Simple',
					new_you: 'Um novo você',
					get_to_know: 'Venha conferir',
					next: 'Avançar'
				},
				ru: {
					title: 'Узнайте, что принесет вам 2022 год',
					set: 'Ставьте',
					with_personal_offer: 'с нашим персональным предложением',
					title2: '{0} цели на новый год {1}',
					new_year: 'Новый год',
					new_simple: 'Новый Simple',
					new_you: 'Новые цели',
					get_to_know: 'Начинаем!',
					next: 'Далее'
				}
			}
		})

		const language = computed(() => locale.value)

		const Layout = computed(() => config.get({ key: 'layout', default_value: 'New Year - 2022' }))
		const isOnboarded = computed(() => store.getters['survey/isOnboarded'])
		const hasSubscription = computed(() => config.get({ key: 'hasSubscription', default_value: false }))
		const next = computed(() => {
			let paywall_router = hasSubscription.value ? 'workbooks-bundle' : 'ny22-paywall'
			return isOnboarded.value ? paywall_router : 'improving-life'
		})

		const close = (Status = 'Close') => {
			amplitude.logEvent('Pre Paywall - Close', {
				Layout,
				From: store.getters['getSource'],
				Step: 'Pre Paywall',
				Status
			})
			router.push({
				name: next.value
			})
		}

		const goNext = () => close()

		onMounted(() => {
			setTimeout(() => {
				amplitude.logEvent('Pre Paywall - Show', {
					Layout,
					From: store.getters['getSource'],
					Step: 'Pre Paywall'
				})
			}, 500)
		})

		return {
			t,
			goNext,
			isOnboarded,
			language
		}
	}
}
</script>

<style lang="scss" scoped>
.bg {
	background-image: url(~@/assets/pre/ny-home-bg.png);
	background-size: cover;
	background-repeat: no-repeat;
	background-position: 50% 50%;
}

.title {
	color: #fff;
	padding-top: 8vh;
	font-size: 1.7rem;
	text-align: center;
	font-weight: bold;
	max-width: 90%;
	margin-left: auto;
	margin-right: auto;
	line-height: 1.2;

	@media (min-height: 700px) {
		font-size: 1.9rem;
	}
}

.title-onboarded {
	padding-top: 3vh;
	font-size: 2.2rem;
	text-align: center;
	font-weight: bold;
	max-width: 90%;
	margin-left: auto;
	margin-right: auto;
	line-height: 1.2;

	@media (min-height: 700px) {
		font-size: 2.4rem;
		padding-top: 4vh;
	}
}

.color-purple {
	color: #e46a8a;
}

.promo {
	img {
		max-height: 55vh;
		display: block;
		margin-left: auto;
		margin-right: auto;
	}
}

.subtitle {
	text-align: center;
	margin-top: 1rem;

	svg {
		height: 3.1rem;
	}
	text {
		font-weight: bold;
	}
}

.list {
	text-align: center;
	color: #fff;
	margin-bottom: 1rem;

	&.dark {
		color: #8d8d8d;

		.simple {
			color: #000;
		}
	}

	@media (min-height: 700px) {
		margin-bottom: 1.5rem;
	}

	span {
		font-weight: 500;
	}

	i {
		display: inline-block;
		margin: 0 10px;
	}
}

.btn {
	margin-bottom: 10px;
}

[lang='ru'] {
	.title-onboarded {
		font-size: 2rem;
	}
	.title {
		font-size: 2rem;
	}
	.promo {
		img {
			max-height: 52vh;
		}
	}
}
[lang='fr'],
[lang='it'],
[lang='de'],
[lang='pt'] {
	.title-onboarded {
		font-size: 1.8rem;
	}
	.promo {
		img {
			max-height: 52vh;
		}
	}
}
</style>
